<p-progressBar
*ngIf="coreService.isLoading"
  [style]="{
    height: '6px',
    width: '100vw',
    position: 'absolute',
    'z-index': 999,
    top: '80px'
  }"
  mode="indeterminate"
></p-progressBar>

<!-- License Status Indicator -->
<div class="license-status" *ngIf="channelState$ | async as state">
  <div class="license-indicator" 
       [ngClass]="{
         'status-acquiring': !state.licensesAssigned && state.clientIds.length > 0,
         'status-active': state.licensesAssigned,
         'status-error': !state.licensesAssigned && state.clientIds.length === 0
       }"
       [pTooltip]="getTooltipContent(state)"
       tooltipPosition="bottom"
       [showDelay]="150"
       [escape]="false"
       [tooltipStyleClass]="'license-tooltip'">
    <i class="pi" [ngClass]="{
      'pi-spin pi-spinner': !state.licensesAssigned && state.clientIds.length > 0,
      'pi-check-circle': state.licensesAssigned,
      'pi-times-circle': !state.licensesAssigned && state.clientIds.length === 0
    }"></i>
    <span>{{ !state.licensesAssigned && state.clientIds.length > 0 ? 'Obteniendo Licencia...' : 
            (state.licensesAssigned ? 'Licencia Activa' : 'Error de Licencia') }}</span>
  </div>
</div>

<wfc-master-page>
  
  <router-outlet></router-outlet>
</wfc-master-page>

<lesmes-app-notifications-sidebar></lesmes-app-notifications-sidebar>

<style>
.license-status {
  position: fixed;
  top: 20px;
  right: 80px;
  z-index: 1000;
}

.license-indicator {
  display: flex;
  align-items: center;
  opacity:0;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.status-acquiring {
  background-color: #F8F9FA;
  color: #6C757D;
  border: 1px solid #E9ECEF;
}

.status-active {
  background-color: #D4EDDA;
  color: #155724;
  border: 1px solid #C3E6CB;
}

.status-error {
  background-color: #F8D7DA;
  color: #721C24;
  border: 1px solid #F5C6CB;
}
</style>
